import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

function StoryCircle({
  puzzleId, username, avatarUrl, hasNewStory,
}) {
  // Get initials for avatar fallback
  const initials = username
    ? username.slice(0, 2).toUpperCase()
    : '??';

  return (
    <Link
      to={`/play/${puzzleId}`}
      className="flex flex-col items-center gap-1 flex-shrink-0"
    >
      {/* Story ring */}
      <div
        className={`p-[2px] rounded-full ${
          hasNewStory ? 'story-ring-gradient' : 'bg-gray-300'
        }`}
      >
        {/* White inner border */}
        <div className="bg-white p-[2px] rounded-full">
          {/* Avatar */}
          <div className="w-14 h-14 rounded-full bg-gray-200 overflow-hidden flex items-center justify-center">
            {avatarUrl ? (
              <img
                src={avatarUrl}
                alt={username}
                className="w-full h-full object-cover"
              />
            ) : (
              <span className="text-sm font-semibold text-gray-500">
                {initials}
              </span>
            )}
          </div>
        </div>
      </div>

      {/* Username */}
      <span className="text-xs text-puzzle-text w-16 text-center truncate">
        {username}
      </span>
    </Link>
  );
}

StoryCircle.propTypes = {
  puzzleId: PropTypes.string.isRequired,
  username: PropTypes.string.isRequired,
  avatarUrl: PropTypes.string,
  hasNewStory: PropTypes.bool,
};

StoryCircle.defaultProps = {
  avatarUrl: null,
  hasNewStory: false,
};

export default StoryCircle;
